module.exports = __webpack_public_path__ + "static/media/tiling-background.22974bb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/tiling-background.png
// module id = 1636
// module chunks = 1